module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/nurse-c7510ba6798631d0ec3f890bed00b7e5.svg";